import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';

import { AvatarModule } from '@libs/src/avatar/avatar.module';
import { FilterMembershipsPipeModule } from '@libs/src/filter-memberships-pipe/filter-memberships-pipe.module';
import { GroupsStoreModule } from '@libs/src/groups/groups-store/groups-store.module';
import { VisibleGroupsModule } from '@main-client/src/app/core/visible-groups.module';
import { HeaderModule } from '@main-client/src/app/header/header.module';
import { GroupMembershipPipeModule } from '@main-client/src/app/pipes/group-membership-pipe/group-membership-pipe.module';
import { MostReadableColorModule } from '@main-client/src/app/pipes/most-readable-color/most-readable-color.module';

import { AccountBackend } from '@libs/src/account/account.backend';
import { GroupsBackend } from '@libs/src/groups/groups.backend';
import { FeedEffects } from '@main-client/src/app/feed/feed-effects.service';
import { GroupViewNavigationService } from '@main-client/src/app/group-view/group-view-navigation.service';

import { GroupViewComponent } from './group-view.component';

@NgModule({
  imports: [
    AvatarModule,
    CommonModule,
    EffectsModule.forFeature([FeedEffects]),
    FilterMembershipsPipeModule,
    FlexLayoutModule,
    GroupMembershipPipeModule,
    GroupsStoreModule,
    HeaderModule,
    MatIconModule,
    MatListModule,
    MatSidenavModule,
    MostReadableColorModule,
    RouterModule.forChild([]),
    VisibleGroupsModule,
  ],
  declarations: [GroupViewComponent],
  exports: [GroupViewComponent],
  providers: [AccountBackend, GroupsBackend, GroupViewNavigationService],
})
export class GroupViewModule {}
